/**
 * Whether the Details panel is read-only, provided once by `PanelShell` from
 * its `readOnly`. Every field widget reads it and, when set, shows its value
 * as plain text (`ReadOnlyField`) instead of an editor, so the inspectors
 * pass nothing down.
 */
import { createContext, useContext } from 'react';

export const PanelReadOnlyContext = createContext(false);

export const usePanelReadOnly = (): boolean => useContext(PanelReadOnlyContext);
